import templateUrl from 'emun.salesrep/territory-manager/division/division-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import DivisionPrompt from "emun.salesrep/territory-manager/division/division-prompt";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class DivisionListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryDivisions.json',
			autoLoad: true,
			hideLeftNav: true,
			orderBy: "Name",
			sortOptions: {
				'Name': 'Name: A to Z',
				'-Name': 'Name: Z to A',
				"RepGroup": "Rep Group: A to Z",
				"-RepGroup": "Rep Group: Z to A"
			}
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("divisionSaved", () => $ctrl.query.load(true));
    }
	applyTerritoryChanges() {
		const $ctrl = this;
		modals.confirm("Apply Territory Changes").result.then(() => {
			$ctrl.bus.send("RebuildCustomerSalesRepAccess.json?UpdateCustomerRep=true").then(() => {
//				modals.alert("Territory Changes Applied Succesfully");
				$ctrl.bus.send("RebuildAgencyRepVendorAccess.json").then(() => {
					modals.alert("Territory Changes Applied Succesfully");
				});
			});
		});
	}
	create() {
		const $ctrl = this;
		modals.prompt('Division Name...').result.then(name => {
			$ctrl.bus.send("CreateDivision.json", {
				id: name,
				name: name 
			})
			.then(function (res) {
				$ctrl.$state.transitionTo("division", {divisionId: res.data.id});
				// DivisionPrompt.open({ division: res.data, divisionId: res.data.id });
			});
		});


	}

	edit(division) {
		const $ctrl = this;
		DivisionPrompt.open({ division: division, divisionId: division.id });
	}

	delete(division) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + division.name, "Delete Division?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteDivision.json", division)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let DivisionList = {
	controller: DivisionListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default DivisionList;
